import React from "react";
import Help from "./Help";
import "../../style/scss/FormInput.scss"; // Updated to use SCSS instead of CSS

export default function FormTextArea(props) {
   var label = props.label || props.field;
   var field = props.field || props.label;
   if (!label) console.error("FormInput requires a field or label property");
   const obj = props.formObject?.object || {};
   const camel = field ? field.charAt(0).toLowerCase() + field.slice(1) : "";
   const fieldValue = props.value || obj[field] || (camel && obj[camel]) || "";
   if (field && !Object.prototype.hasOwnProperty.call(obj, field) && !(camel && Object.prototype.hasOwnProperty.call(obj, camel)))
      console.log("The object specified does not have a " + field + " property");

   function onChange(e) {
      props.formObject.onChange(e.target.value, field, "FormTextArea", e);
   }
   return (
      <div
         className={`field FormTextArea form-group${props.invalid ? " field-invalid" : ""}${props.className ? ` ${props.className}` : ""}`}
         hidden={props.hidden || undefined}
      >
         {label && (
            <label htmlFor={field} className="form-label">
               {label}
            </label>
         )}
         <textarea
            id={field}
            name={field}
            rows={props.rowsmin || 3}
            value={fieldValue}
            onChange={onChange}
            className={props.invalid ? "field-invalid-control" : undefined}
         />
         {props.helpid ? <Help id={props.helpid} /> : ""}
      </div>
   );
}
